import { mapState } from 'vuex';

export default {
  computed: mapState({
    permissions: state => state.guard.permissions,
  }),
  methods: {
    $_can(permission) {
      return this.permissions.indexOf(permission) >= 0;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/mixins/can.js